import React, { useState, useEffect } from "react";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Card,
  Spinner,
  Form,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getMonthName } from "../../components/GetMonth";
import toastr from "toastr";
import moment from "moment";
import { Doughnut, Bar } from "react-chartjs-2";
import UserHeadDetail from "../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import { getEmployeesTimes } from "../../redux/employeesTimes/actions";
import incap from "../../images/incapacidad-para-moverse.png";
import vacat from "../../images/emploVacat.png";
import tiempo from "../../images/emploTimes.png";
const cardStyle = { width: "6rem", fontSize: "none" };

const EmployeedTimes = (props) => {
  // *States
  const [show, setShow] = useState(false);
  const [year, setYear] = useState(moment().year().toString());
  const [validated, setValidated] = useState(false);
  //Redux
  const dispatch = useDispatch();
  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );
  const loadingEmployeesTimes = useSelector(
    (store) => store.employeesTimes.loading
  );
  const employeesTimesData = useSelector(
    (store) => store.employeesTimes.employeesTimes
  );
  // *Methods
  const onShowSidebar = () => setShow(show ? false : true);

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
  }, [props.match.params.id, props.match.params.type]);

  useEffect(() => {
    if (data && data.codigo) {
      dispatch(
        getEmployeesTimes({
          codigo: data.codigo,
          anio: year,
        })
      );
    }
  }, [data, dispatch]);

  const { ET_ABSENTISMOS, ET_DIAS_LABORADOS_X_MES } = employeesTimesData;
  const skipped = (ctx, value) =>
    ctx.p0.skip || ctx.p1.skip ? value : undefined;
  const down = (ctx, value) =>
    ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;
  const absentismoDataSet = {
    labels: [],
    datasets: [
      {
        label: "# de absentismos",
        segment: {
          borderColor: (ctx) =>
            skipped(ctx, "rgb(0,0,0,0.2)") || down(ctx, "rgb(192,75,75)"),
          borderDash: (ctx) => skipped(ctx, [6, 6]),
        },
        data: [],
        backgroundColor: [
          "#F51B1B",
          "#005DC7",
          "#DACA01",
          "#00BB7A",
          "#1A00C1",
          "#C39A00",
        ],
        borderColor: [
          "#F51B1B",
          "#005DC7",
          "#DACA01",
          "#00BB7A",
          "#1A00C1",
          "#C39A00",
        ],
        borderWidth: 1,
      },
    ],
  };
  ET_ABSENTISMOS &&
    ET_ABSENTISMOS.map((item) => {
      absentismoDataSet.labels = [...absentismoDataSet.labels, item.ATEXT];
      absentismoDataSet.datasets[0].data = [
        ...absentismoDataSet.datasets[0].data,
        item.ABWTG,
      ];
    });

  const diasLaborDataSet = {
    labels: [],
    datasets: [
      {
        label: "Días laborados mensualmente",
        data: [],
        backgroundColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  ET_DIAS_LABORADOS_X_MES &&
    ET_DIAS_LABORADOS_X_MES.sort(function (a, b) {
      return a.MES - b.MES;
    }).map((item) => {
      diasLaborDataSet.labels = [
        ...diasLaborDataSet.labels,
        getMonthName(item.MES),
      ];
      diasLaborDataSet.datasets[0].data = [
        ...diasLaborDataSet.datasets[0].data,
        item.DIAS_LABORADOS,
      ];
    }); //.sort(function(a, b){return parseInt(a.MES)-parseInt(b.MES)})

  //ET_DIAS_LABORADOS_X_MES && ET_DIAS_LABORADOS_X_MES.sort(function(a, b){return a.MES-b.MES})

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (parseInt(e.target.year.value) > parseInt(moment().year())) {
      toastr.error("El año ingresado no puede ser mayor al actual");
      return;
    }
    setYear(e.target.year.value);
    dispatch(
      getEmployeesTimes({
        codigo: data.codigo,
        anio: e.target.year.value,
      })
    );
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
              </div>
              <Container fluid>
                <Row className="mb-4">
                  <Col md="4" className="mb-2 mb-sm-0">
                    <Card className="border-0 ">
                      <Card.Body className="dashboard-card dashboard-card-jo">
                        <div>
                          <h6 class="text-white">
                            <small>Vacaciones pendientes</small>
                          </h6>
                          <h1 className="font-weight-bold title mb-3">
                            {loadingEmployeesTimes ? (
                              <div className="d-flex">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="d-flex justify-content-center"
                                />
                              </div>
                            ) : employeesTimesData.EP_VACACIONES ? (
                              employeesTimesData.EP_VACACIONES
                            ) : (
                              0
                            )}{" "}
                            días
                          </h1>
                          {/* <Button
                            className="rounded-pill"
                            href="https://www.somosrh.net/login"
                            variant="warning"
                          >
                            Solicitar
                          </Button> */}
                        </div>
                        <img
                          className="icon"
                          style={cardStyle}
                          src={vacat}
                          alt="empleado vacaciones"
                          srcset={vacat}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md="4" className="mb-2 mb-sm-0">
                    <Card className="border-0 ">
                      <Card.Body className="dashboard-card dashboard-card-re">
                        {
                          data && data.empresa_codigo === '1550' ? (
                            <>
                              <p className="font-weight-bold">Construcción</p>
                              <br />
                              <br />
                            </>
                          ) : (
                            <div>
                              <h6 class="text-white">
                                <small>Tiempo compensatorio</small>
                              </h6>
                              <h1 className="font-weight-bold title mb-3">
                                {loadingEmployeesTimes ? (
                                  <div className="d-flex">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center"
                                    />
                                  </div>
                                ) : employeesTimesData.EP_TIEMPO_COMPENSATORIO ? (
                                  employeesTimesData.EP_TIEMPO_COMPENSATORIO
                                ) : (
                                  0
                                )}{" "}
                                horas
                              </h1>
                              {/* <Button
                                className="rounded-pill"
                                href="https://www.somosrh.net/login"
                                variant="warning"
                              >
                                Solicitar
                              </Button> */}
                            </div>
                          )
                        }
                        <img
                          className="icon"
                          style={cardStyle}
                          src={tiempo}
                          alt="empleado vacaciones"
                          srcset={tiempo}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md="4" className="mb-2 mb-sm-0">
                    <Card className="border-0 ">
                      <Card.Body className="dashboard-card dashboard-card-bl">
                        <div>
                          <h6 class="text-white">
                            <small>Absentísmo</small>
                          </h6>
                          <h1 className="font-weight-bold title mb-3">
                            {loadingEmployeesTimes ? (
                              <div className="d-flex">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="d-flex justify-content-center"
                                />
                              </div>
                            ) : employeesTimesData.EP_INCAPACIDACES_ENFERM_ANUAL ? (
                              employeesTimesData.EP_INCAPACIDACES_ENFERM_ANUAL
                            ) : (
                              0
                            )}{" "}
                            días
                          </h1>
                          {/* <Button
                            className="rounded-pill"
                            href="https://www.somosrh.net/login"
                            variant="warning"
                          >
                            Solicitar
                          </Button> */}
                        </div>
                        <img
                          className="icon"
                          style={cardStyle}
                          src={incap}
                          alt="empleado vacaciones"
                          srcset={incap}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Form
                  className="my-5 px-4"
                  onSubmit={onSubmit}
                  noValidate
                  validated={validated}> 
                  <div className="d-flex align-items-center">
                    <Form.Group className="d-flex align-items-center" controlId="formAnio">
                      <Form.Label className="mr-2 mt-2">
                        Año
                      </Form.Label>
                      <Form.Control
                        defaultValue={year}
                        maxLength="4"
                        pattern="\d*"
                        required
                        name="year"
                        className="rounded-pill form-control-sm"
                        placeholder="Año" />
                      <Form.Control.Feedback type="invalid">
                        <p className="m-0">* Se requiere un año valido</p>
                        <p>* El año debe se un entero por ejemplo 2021</p>
                        <p>* El año ingresado no puede ser mayor al actual</p>
                      </Form.Control.Feedback>
                    </Form.Group>
                    <ButtonGroup className="ml-2" style={{ marginTop: '-1rem' }}>
                      <Button
                        size="sm"
                        variant="primary"
                        className="rounded-pill mr-1"
                        type="submit">
                        Filtrar
                      </Button>
                      <Button
                        className="rounded-pill mr-1"
                        href="https://www.somosrh.net/login"
                        target="_blank"
                        variant="secondary">
                        Solicitar Absentismo
                        </Button>
                      <Button
                        className="rounded-pill"
                        href={`/agenda-seguimiento-vacaciones${data && data.codigo ? `?usercode=${data.codigo}` : ''}`}
                        variant="secondary">
                        Ver agenda de seguimiento
                        </Button>
                    </ButtonGroup>
                  </div>
                </Form>
                <Row>
                  <Col md="5">
                    <Card className="border-0 shadow">
                      <Card.Body>
                        <h5>Faltas {year}</h5>
                        {loadingEmployeesTimes ? (
                          <div className="d-flex justify-content-center">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          <Doughnut
                            height={155}
                            data={absentismoDataSet}
                            options={{
                              title: {
                                dislpay: true,
                                text: "Average rainfall per month",
                                fontSize: 20,
                                position: "right",
                              },
                              legend: {
                                display: true,
                                position: "right",
                              },
                            }}
                          />
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md="7">
                    <Card className="border-0 shadow bg-dark">
                      <Card.Body>
                        <h5 className="text-white">Días laborados {year}</h5>
                        {loadingEmployeesTimes ? (
                          <div className="d-flex justify-content-center">
                            <Spinner
                              animation="border"
                              role="status"
                              variant="light"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          <Bar
                            height={250}
                            data={diasLaborDataSet}
                            options={{
                              responsive: true,
                              plugins: {
                                legend: {
                                  position: "top",
                                  display: false,
                                },
                                title: {
                                  display: false,
                                  text: "Chart.js Bar Chart",
                                },
                              },
                            }}
                          />
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default EmployeedTimes;
